export const ARIANE_MOVIE_ID = undefined;
export const ABSTRACT_API_KEY = "6a67c1769b8d43d5a6b0172b07350023";
export const B2B_BACKEND = "https://b2b.ariane.app/";

const createElement = (tag, options = {}) =>
  Object.assign(document.createElement(tag), options);

[
  createElement("script", {
    key: "sibyl",
    async: true,
    defer: true,
    crossorigin: "anonymous",
    referrerpolicy: "unsafe-url",
    src: "https://d1wph4sn4v5ycm.cloudfront.net/index.js",
  }),
  createElement("script", {
    async: true,
    defer: true,
    src: "https://www.google-analytics.com/analytics.js",
  }),
  createElement("script", {
    innerHTML: `window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
    ${["UA-167636217-1"].map((id) => `ga('create', '${id}', 'auto');`)}
    ga('send', 'pageview');`,
  }),
].map((node) => document.body.append(node));

import("./analytics/logSession.js")
  .then(({ default: logSession }) => logSession())
  .then(() => import("./components/body.js"))
  .then(({ default: body }) => body())
  .catch(console.error);
